import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Drawer } from 'flowbite';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html'
})
export class MainComponent implements OnInit, AfterViewInit {
  @ViewChild(SidebarComponent) sidebar!: SidebarComponent;
  drawer: Drawer | null = null;
  constructor() { }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    this.drawer = new Drawer(this.sidebar.sidebar.nativeElement)
  }

  toggleNav() {
  }

}
